
export const getInsuranceTypeListApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `/insurance-types${queryString ? `?${queryString}` : ''}`;
};

// POST new InsuranceType
export const addInsuranceTypeApi = (params) => {
    return `/insurance-types`;
};

// PUT edit InsuranceType
export const updateInsuranceTypeApi = (params) => {
    return `/insurance-types/${params?.asset_slug}`;
};

// DELETE InsuranceType
export const deleteInsuranceTypeApi = (params) => {
    return `/insurance-types`;
};

// EXPORT InsuranceType
export const exportInsuranceTypeApi = (leaseId) => {
    return `lease/${leaseId}/insurance-types`;
};
